<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12sDPTx/tc-custom/9781913118228.jpg?1726483594492" alt="This image is the cover for the book Mongol Conquests"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mongol Conquests
      </h1>
      <p class="bookDescription body article font2">
        <b>“A scholarly, detailed history of how the Mongols created the greatest landlocked empire in history” (<i>Midwest Book Review</i>).</b><br/><br/>The Mongols created the greatest landlocked empire known to history. It was an empire created and sustained by means of conquest. Initially an insignificant tribal leader, Genghis Khan gradually increased his power, overcoming one rival after another. After he had subjugated all tribes of Inner Asia, he struck southward into China and later attacked distant Khwarizm in the Near East. Sübe’etei continued to make significant conquests after Genghis Khan died, conquering central China and leading a large force into the heart of Europe. Between them, Genghis Khan and Sube’etei directed more than 40 campaigns, fought more than 60 battles, and conquered all lands from Korea in the east to Hungary and Poland in the west.<br/><br/>This book offers a detailed narrative of the military operations of these two leaders, based on early Mongolian, Chinese, Near Eastern, and European sources. Making full use of Chinese sourced not translated properly into any European language, the account offer details never before given in English works. Detailed maps showing the operations support the text. Many conventional wisdom views of the Mongols, such as their use of terror as a deliberate strategy, or their excellence at siege warfare, are shown to be incorrect. This is a major contribution to our knowledge of the Mongols and their way of warfare.<br/><br/><b>“History is littered with great leaders leading great armies and conquering large swathes of the world—Attila the Hun, Alexander the Great, the Roman Empire . . . but none perhaps as staggering as that of Genghis Khan. I have never heard of Sube’etei, I’m ashamed to say, until now, in this excellent book by Carl Fredrik Sverdrup. Asian history has never particularly appealed to me, but this is big history, and the author’s style makes it compelling and readable.” —<i>Books Monthly</i></b><br/><br/><b>“This is a very valuable addition to the literature on the Mongol conquests, giving us a much clearer idea of the detailed course of their campaigns, the world in which they took place, and the methods used to win them.” —<i>History of War</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carl Fredrik Sverdrup
      </h2>
      
      <p class="authorDescription body article">Carl Fredrik Sverdrup is a Scandinavian living in Switzerland. He studied engineering and business, and has a career in international business management. He has a long-standing interest in military strategy and history. He has published articles on the Mongols with Journal of Medieval Military History (Numbers in Mongol Warfare, 2012) and Journal of Asian History (Sübe’etei Ba’atur, Anonymous Strategist, 2013). The Mongol Conquests is his first book. He is married and has two children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Helion and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70c9f586